import { useEffect, useState } from "react";

import _ from "lodash";
import { getGroupDetails } from "../../apis/GrapeList";
import Loader from "../../components/Loader/Loader";
import { GrapeListProvider } from "../../components/GrapeList/context/GrapeListProvider";
import { GrapeListForm } from "../../components/GrapeList/GrapeListForm";
import { useParams } from "react-router-dom";

export const EditGrapeList = () => {
	const [grapeList, setGrapeList] = useState();
	const { id } = useParams();

	useEffect(() => {
		_.debounce(async () => {
			const list = await getGroupDetails(id);
			setGrapeList(list);
		}, 500)();
	}, [id]);

	return (
		<GrapeListProvider>
			{grapeList ? (
				<GrapeListForm mode="edit" grapeList={grapeList} />
			) : (
				<Loader />
			)}
		</GrapeListProvider>
	);
};
